import { SatelliteAlt } from "@mui/icons-material";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chatData: "",
  chatType: "",
  chatId: "",
  aiBotChatDetails: null,
};

const aiChatReducer = createSlice({
  name: "aiChatReducer",
  initialState,
  reducers: {
    setChatData(state, action) {
      state.chatData = action.payload;
    },
    setAiBotChatDetails(state, action) {
      state.aiBotChatDetails = {
        aiBotChatId: action.payload.aiBotChatId,
        aiBotChatData: action.payload.aiBotChatData,
        faqOptionsList: action.payload.faqOptionsList,
      };
    },
    clearAiBotChatDetails(state) {
      state.aiBotChatDetails = null;
    },
    setChatType(state, action) {
      state.chatType = action.payload;
    },
    setChatId(state, action) {
      state.chatId = action.payload;
    },
  },
});
export const {
  setChatData,
  setAiBotChatDetails,
  clearAiBotChatDetails,
  setChatType,
  setChatId,
} = aiChatReducer.actions;
export default aiChatReducer.reducer;
